import { createAuthClient } from 'better-auth/react';
import { inferAdditionalFields } from 'better-auth/client/plugins';

/**
 * 🔐 عميل Better Auth — يُستخدم في الكومبوننتس عبر hooks
 * مثال:
 *   const { data: session } = authClient.useSession();
 *   await authClient.signIn.email({ email, password });
 */
// 🌐 baseURL:
//   • dev: http://localhost:3000 (الـ API على بورت مختلف عن vite)
//   • prod: نفس origin الـ frontend (الفرونت + API على نفس الدومين)
const apiBaseURL =
  import.meta.env.VITE_API_URL ||
  (import.meta.env.DEV
    ? 'http://localhost:3000'
    : (typeof window !== 'undefined' ? window.location.origin : ''));

export const authClient = createAuthClient({
  baseURL: apiBaseURL,
  plugins: [
    inferAdditionalFields({
      user: {
        phone:            { type: 'string' },
        phoneVerified:    { type: 'boolean' },
        role:             { type: 'string' },
        verified:         { type: 'boolean' },
        verificationTier: { type: 'string' },
        status:           { type: 'string' },
        city:             { type: 'string' },
        trustedBidder:    { type: 'boolean' },
      },
    }),
  ],
});

export const { signIn, signOut, signUp, useSession, getSession } = authClient;
